<template lang="pug">
  .flx-hero-video.h-screen.bg-black.relative.text-white.select-none(:style="{height: `${winH}px`, cursorOff: !showUI ? 'none' : 'default'}", @mousemove="onMouseMove")
    //- videos
    figure.absolute.inset-0.w-full.h-full
      transition-group(name="fade")
        //- intro
        video.absolute.inset-0.w-full.h-full.object-cover.trans-quick(key="intro", id="intro", v-show="active === 'intro'", ref="intro", v-if="videoIntro", :src="bestSrc(videoIntro)[1]", autoplay, loop, muted, @playing="loaded = true", :class="{'opacity-0': !loaded}", playsinline)
        //- full
        video.absolute.inset-0.w-full.h-full.object-cover(key="full", id="full", v-show="active === 'full'", ref="full", v-if="videoFull", :src="bestSrc(videoFull)[1]", @loadedmetadata="canplay = true", @play="playing = true", @pause="playing = false", @ended="afterFullEnds")
        //- outro
        video.absolute.inset-0.w-full.h-full.object-cover(key="outro", id="outro", v-show="active === 'outro'", ref="outro", v-if="videoOutro", :src="bestSrc(videoOutro)[1]", loop, muted, playsinline)
    //- type layer
    transition(name="fade")
      .absolute.inset-0.flex.items-center.justify-center(v-show="showUI")
        h2.font-blau.leading-none.text-68.md-text-100.break-all.md-break-normal.text-center {{row.title}}

        //- play btn
        button.absolute.bottom-0.left-0.m-15.md-ml-34.md-mb-20.md-pb-px.flex.items-center(v-if="videoFull", @click="onPlayBtn", v-show="canplay")
          span.block.h-30.w-30.mr-12
            img.block.w-full(src="@/assets/icons/play--encircled.svg", v-show="!playing")
            img.block.w-full(src="@/assets/icons/pause--encircled.svg", v-show="playing")
          span.text-13.hidden.md-inline {{ playing ? 'Pause' : 'Play' }}

        footer.flex.absolute.w-full.bottom-0.left-0.pb-15.md-pb-24.pointer-events-none.justify-center(v-if="row.button_link")
          wp-link.pointer-events-auto(:link="row.button_link")
            btn.min-w-btn-sm.md-min-w-btn(type="hero-cta") {{row.button_link.title}}
</template>

<script>
import Observer from '@/components/IntersectionObserver'
import { mapState, mapMutations } from 'vuex'
import Btn from '@/components/Btn'
import wpLink from '@/components/WPLink'
import _throttle from 'lodash/throttle'
import { toggleiOSVideoFull } from '@/utils'
export default {
  name: 'Flx__HeroVideo',
  props: ['row'],
  data () {
    return {
      active: 'intro',
      loaded: false, // intro
      canplay: false, // full
      playing: false, // full
      showUI: true,
      mouse: { xy: null, inactive: null },

      videoIntro: null,
      videoFull: null,
      videoOutro: null,

      winH: window.innerHeight,
      dpx: window.devicePixelRatio
    }
  },
  computed: {
    ...mapState(['ui', 'canHover'])
  },
  methods: {
    ...mapMutations({ setUI: 'SET_UI' }),
    getVideo (key, id) {
      this.$store.dispatch('getMedia', { id: id, wpnonce: this.$route.query.preview })
        .then(media => { this[key] = media })
    },
    bestSrc (video) {
      const srcs = video.sources
      const h = this.winH * this.dpx * 0.85
      const best = srcs.find(src => src[0] >= h)
      return best || (srcs.length && srcs[srcs.length - 1])
    },
    pause (id = 'xx') {
      const video = this.$refs[id]
      return video && !video.paused && video.pause()
    },
    onPlayBtn () {
      this.active = 'full'
      if (!this.$refs.full.paused) return this.$refs.full.pause()
      // fullscreen on ios touch
      if (!this.canHover) toggleiOSVideoFull(this.$refs.full, 'fullscreen')
      // play
      return this.$refs.full.play()
    },
    onMouseMove: _throttle(function (e) {
      // ensure mouse actually moved (safari bug)
      const xy = [e.x, e.y].join(',')
      if (this.mouse.xy === xy) return
      // show UI, save pos
      this.showUI = true
      this.mouse.xy = xy
      clearTimeout(this.mouse.inactive)
      // hide ?
      if (!this.playing || e.target.parentNode.href) return
      this.mouse.inactive = setTimeout(() => {
        this.showUI = false
      }, 1000)
    }, 100),
    afterFullEnds () {
      const video = this.$refs.outro || this.$refs.intro
      video.play()
      this.active = video.id
    },
    onScroll: _throttle(function () {
      const y = window.pageYOffset
      const color = y >= this.winH - 50 ? null : this.row.ui_color
      if (this.ui !== color) this.setUI(color)
    }, 50),
    onResize () {
      this.winH = window.innerHeight
    }
  },
  watch: {
    active (val, old) {
      old = this.$refs[old]
      return old && old.pause()
    },
    playing () {
      this.showUI = !this.playing
      // TODO - hide appheader ui too...
    }
  },
  created () {
    this.setUI(this.row.ui_color)
    this.getVideo('videoIntro', this.row.video_clip_intro.video_file)
    this.getVideo('videoFull', this.row.video.video_file)
    this.getVideo('videoOutro', this.row.video_clip_outro.video_file)
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
    this.$store.state.bus.$on('newWindowWidth', this.onResize)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
    this.$store.state.bus.$off('newWindowWidth', this.onResize)
    this.setUI()
  },
  components: { Observer, Btn, wpLink }
}
</script>

<style>
</style>
